import React, { useState } from "react";
import Slider from "react-slick";
// import ClientPropOne from "./ClientPropOne";
import ProjectData from "../../data/client/ClientData.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IncreasedSizeClientPropOne from "./IncreasedSizeClientPropOne";

const ClientOne = ({ parentClass, colSize, itemShow = 4, columnGap }) => {
  // eslint-disable-next-line no-unused-vars
  const [sliderRef, setSliderRef] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: itemShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed:100,
    arrows: true,
    className: "client-slides",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, itemShow),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, itemShow),
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className={`section ${parentClass || ""}`} style={{padding:'70px 0 0'}}>
      <div className="container">
        <div className="client-slider">
          {/* <div className="slider-navigation">
            <div className="navigation-wrapper">
              <button className="custom-prev-arrow" onClick={() => sliderRef?.slickPrev()}>
                <span>&larr;</span>
              </button>
              <button className="custom-next-arrow" onClick={() => sliderRef?.slickNext()}>
                <span>&rarr;</span>
              </button>
            </div>
          </div> */}
          <Slider ref={setSliderRef} {...settings}>
            {ProjectData.map((data) => (
              <div key={data.id} className={`client-slide-item ${colSize || ""}`}>
                <IncreasedSizeClientPropOne projectStyle="" portfolio={data} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ClientOne;